import * as React from 'react';

import { StoreApi } from 'zustand';

import { DrawerContext } from '@notino/react-styleguide';
import { WishlistList } from '@notino/shared/definitions/types';

const Context = React.createContext<{
  store: ListMenuDrawerStore;
  onClose: () => void;
}>(null);

export const useListMenuContext = () => React.useContext(Context);
export const ListMenuContextProvider = Context.Provider;

export type ListMenuDrawerStoreValue = {
  list: (WishlistList & { isShared?: boolean }) | null;
  currentAction: 'rootMenu' | 'rename' | 'delete' | 'share' | 'addToCart';
};

export type ListMenuDrawerStore = StoreApi<ListMenuDrawerStoreValue>;

export const useCloseListMenuDrawer = () => {
  const { closeDrawer } = DrawerContext.useDrawerContext();
  const { onClose } = useListMenuContext();

  return React.useCallback(() => {
    closeDrawer();
    onClose();
  }, [closeDrawer, onClose]);
};
